import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditStarIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M4.20498 17.9896C3.99389 17.9896 3.7828 17.9193 3.59516 17.7785C3.21989 17.4971 3.07916 17.0514 3.21989 16.6058L4.83825 11.6334C4.90862 11.4223 4.83825 11.1644 4.65062 11.0471L0.428802 7.97454C0.0535294 7.69308 -0.0871976 7.24745 0.0535296 6.80181C0.194257 6.35617 0.592983 6.07472 1.03862 6.07472H6.26898C6.50352 6.07472 6.71461 5.93399 6.78498 5.69945L8.40334 0.72709C8.54407 0.281454 8.94279 0 9.38843 0C9.83406 0 10.2328 0.281454 10.3735 0.72709L11.9684 5.7229C12.0388 5.93399 12.2499 6.09817 12.4844 6.09817H17.7148C18.1839 6.09817 18.5591 6.37963 18.6999 6.82526C18.8406 7.2709 18.6999 7.71654 18.3246 7.99799L14.1028 11.0705C13.9151 11.2113 13.8448 11.4458 13.9152 11.6569L15.5335 16.6293C15.6742 17.0749 15.5335 17.5205 15.1582 17.802C14.783 18.0834 14.3139 18.0834 13.9386 17.802L9.71679 14.7294C9.52915 14.5887 9.27116 14.5887 9.08352 14.7294L4.86171 17.802C4.62716 17.9193 4.41607 17.9896 4.20498 17.9896Z" 
        fill={props.fillColor ?? "black"}
      />
    </svg>
  );
}

export default EditStarIcon;